import React from "react";

export interface IAppNavIconProps {
  size?: string | number;
  className?: string;
}

/**
 * The frame of the app's bottom-tab icons (`assets/svg/*_icon.svg`): a 24×24 outline at
 * 1.5px in `currentColor`, so the caller's text colour paints it.
 */
const AppStrokeIcon: React.FC<
  IAppNavIconProps & { children: React.ReactNode }
> = ({ size = 24, className, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
  >
    {children}
  </svg>
);

export default AppStrokeIcon;
